var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Mina butiker")]),_c('ul',_vm._l((_vm.stores),function(store){return _c('li',[_c('router-link',{attrs:{"to":/store/ + store.id}},[_vm._v(_vm._s(store.name))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }